import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Error404 = () => {
    return (
        <>
            <section className="full notfound">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={6}>
                            <div className="box">
                                <h2 className="text-gradient">Oops !</h2>
                                <h1>404 - Page Not Found</h1>
                                <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
                                <Link to="/home" className="button yellow py-3 px-5">Back to Home</Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Error404;